import React, { useState } from "react";
import Slider from "./Slider"; // Supposons que Slider soit votre composant
import "animate.css";
import NB from "./NB";

const SimulateurDepotATerme = ({ titre }) => {
  const [depositAmount, setDepositAmount] = useState(10000000); // Montant du dépôt à terme
  const [annualInterestRate, setAnnualInterestRate] = useState(1); // Taux d'intérêt annuel
  const [depositTermMonths, setDepositTermMonths] = useState(1); // Durée du dépôt en mois
  const [totalInterest, setTotalInterest] = useState(null); // Intérêt total calculé

  const calculateTotalInterest = () => {
    const P = depositAmount;
    const r = annualInterestRate / 100; // Convertir le taux annuel en taux mensuel et en décimal
    const n = depositTermMonths / 12; // La durée est déjà en mois

    // Vérifier si l'une des entrées est nulle ou zéro, ce qui rendrait le calcul invalide
    if (!P || !r || !n) {
      setTotalInterest("Entrée invalide");
      return <div>Entrée invalide</div>;
    }

    const I = P * (1 + r * n);

    setTotalInterest(isFinite(I) ? I : "Entrée invalide"); // Définir l'intérêt total calculé
  };

  const isButtonDisabled =
    !depositAmount || !annualInterestRate || !depositTermMonths;

  return (
    <div className="simulator-container">
      <div className="simulateur-titre">{titre}</div>
      <div className="simulator">
        <div className="simulator-right">
          <Slider
            label="Capital Initial:"
            unit="XOF"
            min={0}
            max={50000000}
            stepCount={2} // Ajuster pour un défilement plus fluide
            value={depositAmount}
            setValue={setDepositAmount}
          />

          <Slider
            label="Rendement:"
            unit="%"
            min={1}
            max={5}
            stepCount={5} // Ajuster pour un défilement plus fluide
            value={annualInterestRate}
            setValue={setAnnualInterestRate}
          />
          <Slider
            label="Durée du dépôt:"
            unit="mois"
            min={0}
            max={60}
            stepCount={5} // Ajuster pour un défilement plus fluide
            value={depositTermMonths}
            setValue={setDepositTermMonths}
          />
          <div className="btn-container">
            <button
              onClick={calculateTotalInterest}
              className="btn-full"
              disabled={isButtonDisabled}
            >
              Lancer la simulation
            </button>
          </div>

          <NB />
        </div>
        {totalInterest !== null && (
          <div className="simulator-left animate__animated animate__zoomInUp">
            <div className="result-row">
              <h3>Capital Initial:</h3>{" "}
              <div className="result-row-variable">
                {depositAmount.toLocaleString("fr-FR")} XOF{" "}
              </div>
            </div>
            <div className="result-row">
              <h3>Rendement:</h3>{" "}
              <div className="result-row-variable">
                {annualInterestRate.toFixed(0)}%{" "}
              </div>
            </div>
            <div className="result-row">
              <h3>Durée du dépôt:</h3>{" "}
              <div className="result-row-variable">
                {depositTermMonths.toFixed(0)} mois{" "}
              </div>
            </div>

            <div className="result-row">
              <h3>Dépôt à terme:</h3>
              <div className="result-row-variable final-result">
                {Math.floor(totalInterest).toLocaleString("fr-FR")} XOF{" "}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SimulateurDepotATerme;
